<template>
  <auto-suggest
    v-model="suggestValue"
    :input-props="{id:'autosuggest__input', class: 'form-control', placeholder:'Pick a country', disabled}"
    :suggestions="filteredCountries"
    :get-suggestion-value="suggestionValue"
    @selected="onSelected"
  >
    <div slot-scope="{suggestion}">
      <div class="flag-wrapper">
        <country-flag :country="suggestion.item.countryAlpha3" size="normal"></country-flag>
      </div>{{suggestion.item.countryLongName}}
    </div>
  </auto-suggest>
</template>
<script>
import { computed, ref, watch } from '@vue/composition-api'
export default {
  props: {
    value: {
      type: String
    },
    countries: {
      type: Array,
      required: true
    },
    disabled: {
      type: String|Boolean
    }
  },
  setup(props, context) {
    const suggestValue = ref('')
    watch(
      () => props.value,
      (v, old) => {
        suggestValue.value = inputCountry(v)
      }
    )
    const filteredCountries = computed(() => {
      return [{
        data: props.countries.filter(item => {
          if (!suggestValue.value) return false
          if (!item.countryLongName) return false
          return item.countryLongName.toLowerCase().includes(suggestValue.value.toLowerCase())
        }).slice(0, 15)
      }]
    })
    function inputCountry(countryAlpha3) {
      if (countryAlpha3 == undefined) {
        return ''
      }
      let country = props.countries.find((item) => item.countryAlpha3 == countryAlpha3)
      if (country) {
        return country.countryLongName
      }
      return ''
    }
    function suggestionValue(suggestion) {
      return suggestion.item.countryLongName
    }
    function onSelected(suggestion, index) {
      context.emit('input', suggestion.item.countryAlpha3)
    }
    return {
      suggestValue,
      filteredCountries,
      suggestionValue,
      onSelected
    }
  }
}
</script>
<style lang="scss">
</style>